import { render } from "./CreateReturnRequestNew.vue?vue&type=template&id=9c9de44e&scoped=true"
import script from "./CreateReturnRequestNew.vue?vue&type=script&lang=js"
export * from "./CreateReturnRequestNew.vue?vue&type=script&lang=js"

import "./CreateReturnRequestNew.vue?vue&type=style&index=0&id=9c9de44e&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9de44e"]])

export default __exports__